import React, { useEffect, useRef, useState } from 'react'
import { Col, Form, Row } from 'antd'
import InputUC from '../../../components/Form/InputUC'
import axiosCommon from '../../../config/axios-common'
import { useSetRecoilState } from 'recoil'
import { isLoadingState } from '../../../recoil/states/default'
import AutoCompleteUC from '../../../components/Form/AutoCompleteUC'
import CheckBoxUC from '../../../components/Form/CheckBoxUC'

const Contact = ({ props }) => {
    const { form } = props
    const [province, setProvince] = useState(null)
    const [provinceCode, setProvinceCode] = useState(null)
    const [isDistrict, setIsDistrict] = useState(false)
    const [isSubDistrict, setIsSubDistrict] = useState(false)
    const [isPostCode, setIsPostCode] = useState(false)
    const [district, setDistrict] = useState(null)
    const [subDistrict, setSubDistrict] = useState(null)
    const [postCode, setPostCode] = useState(null)

    const [currentProvince, setCurrentProvince] = useState(null)
    const [currentProvinceCode, setCurrentProvinceCode] = useState(null)
    const [isCurrentDistrict, setIsCurrentDistrict] = useState(false)
    const [isCurrentSubDistrict, setIsCurrentSubDistrict] = useState(false)
    const [isCurrentPostCode, setIsCurrentPostCode] = useState(false)
    const [currentDistrict, setCurrentDistrict] = useState(null)
    const [currentSubDistrict, setCurrentSubDistrict] = useState(null)
    const [currentPostCode, setCurrentPostCode] = useState(null)
    const isSelect = useRef(false)
    const isCurrentSelect = useRef(false)
    const setIsLoading = useSetRecoilState(isLoadingState)
    const isPermanentAddressWatch = Form.useWatch('isPermanentAddress', form);

    useEffect(() => {
        const fetchProvince = async () => {
            const provinceData = await getDataAddress(null, 'province');
            // console.log('getAllProvince()', provinceData);
            setProvince(provinceData.sort((a, b) => a.label.localeCompare(b.label)));

            const province = form.getFieldValue('province')
            if (province) {
                setProvinceCode(province)
                setIsDistrict(true)
                setIsSubDistrict(true)
                setIsPostCode(true)
                const districtData = await getDataAddress(province, 'district');
                if (districtData && districtData.length > 0) {
                    setDistrict(districtData.sort((a, b) => a.label.localeCompare(b.label)))
                }

                const val = {
                    province: form.getFieldValue('province'),
                    district: form.getFieldValue('district')
                }
                const subDistrictData = await getDataAddress(val, 'subDistrict');
                if (subDistrictData && subDistrictData.length > 0) {
                    setSubDistrict(subDistrictData.sort((a, b) => a.label.localeCompare(b.label)))
                    setPostCode(setDataZipCode(subDistrictData))
                }
            }
        }
        fetchProvince();

        const fetchCurrentProvince = async () => {
            const provinceData = await getDataAddress(null, 'province');
            setCurrentProvince(provinceData.sort((a, b) => a.label.localeCompare(b.label)));

            const province = form.getFieldValue('currentProvince')
            if (province) {
                setCurrentProvinceCode(province)
                setIsCurrentDistrict(true)
                setIsCurrentSubDistrict(true)
                setIsCurrentPostCode(true)
                const districtData = await getDataAddress(province, 'district');
                if (districtData && districtData.length > 0) {
                    setCurrentDistrict(districtData.sort((a, b) => a.label.localeCompare(b.label)))
                }

                const val = {
                    province: form.getFieldValue('currentProvince'),
                    district: form.getFieldValue('currentDistrict')
                }
                const subDistrictData = await getDataAddress(val, 'subDistrict');
                if (subDistrictData && subDistrictData.length > 0) {
                    setCurrentSubDistrict(subDistrictData.sort((a, b) => a.label.localeCompare(b.label)))
                    setCurrentPostCode(setDataZipCode(subDistrictData))
                }
            }
        }
        fetchCurrentProvince();
    }, [])

    const getDataAddress = async (val, type) => {
        switch (type.toLowerCase()) {
            case "province":
                const { data: dataProvince } = await axiosCommon.get("address/listAllProvince");
                // console.log('dataProvince', dataProvince)
                if (dataProvince.provinces) {
                    return dataProvince.provinces.map(item => {
                        return {
                            value: item.provName,
                            label: item.provName,
                            code: `${item.provCode},${item.provName}`,
                        }
                    })
                }
                break;
            case "district":
                const { data: dataDistrict } = await axiosCommon.get(
                    "address/listAumphur?provCode=" + val.split(',')[0]
                );
                if (dataDistrict.aumphurs) {
                    const distinctAmphs = dataDistrict.aumphurs.reduce((accumulator, current) => {
                        const { amphCode, amphName } = current;

                        // check if current object's amphCode value already exists in accumulator
                        if (!accumulator.some(item => item.code.split(',')[0] === amphCode)) {
                            // if not, add current object to accumulator with mapped properties
                            accumulator.push({
                                value: amphName,
                                label: amphName,
                                code: `${amphCode},${amphName}`
                            });
                        }

                        return accumulator;
                    }, []);

                    return distinctAmphs.sort((a, b) => a.label - b.label);
                }
                break;
            case "subdistrict":
                const keyword = "provCode="
                    .concat(val.province.split(',')[0])
                    .concat("&amphCode=")
                    .concat(val.district.split(',')[0]);
                const { data: dataSubDistrict } = await axiosCommon.get(
                    "address/listSubDistrictByProvCodeAndDistrictCode?" + keyword
                );
                if (dataSubDistrict.tumbols) {
                    const distinctTumbols = dataSubDistrict.tumbols.reduce((accumulator, current) => {
                        const { tumbolCode, tumbolName, zipCode } = current;

                        // check if current object's tumbolCode value already exists in accumulator
                        // if (!accumulator.some(item => item.code.split(',')[0] === tumbolCode)) {
                        //     // if not, add current object to accumulator with mapped properties
                        //     accumulator.push({
                        //         value: tumbolName,
                        //         label: tumbolName,
                        //         zipCode: zipCode,
                        //         code: `${tumbolCode},${tumbolName}`
                        //     });
                        // }

                        // Find the existing item in the accumulator with the same tumbolCode
                        const existingItem = accumulator.find(item => item.code.split(',')[0] === tumbolCode);

                        if (existingItem) {
                            // If the tumbolCode already exists, concatenate the zipCode values
                            existingItem.zipCode = `${existingItem.zipCode},${zipCode}`;
                        } else {
                            // If not, add the current object to the accumulator with mapped properties
                            accumulator.push({
                                value: tumbolName,
                                label: tumbolName,
                                zipCode: zipCode,
                                code: `${tumbolCode},${tumbolName}`
                            });
                        }

                        return accumulator;
                    }, []);

                    return distinctTumbols.sort((a, b) => a.label - b.label);
                }
                break;
            default:
                break;
        }
    };

    const onSelectProvince = async (provCode) => {
        const _province = province.find(e => e.value === provCode)
        if (_province) {
            setIsLoading(true)
            const provinceValue = (_province ? _province.code : null)
            setProvinceCode(provinceValue)
            const districtData = await getDataAddress(provinceValue, 'district');
            // console.log('districtData = =>', districtData)
            if (districtData && districtData.length > 0) {
                setDistrict(districtData.sort((a, b) => a.label.localeCompare(b.label)))
            }

            form.setFieldValue('province', provinceValue)
            form.setFieldValue('provinceCode', (_province ? _province.label : null))
            setIsLoading(false)
            setIsDistrict(true)
            setIsSubDistrict(false)
        } else {
            form.resetFields(['province', 'provinceCode'])
            setIsDistrict(false)
            setIsSubDistrict(false)
        }
        form.resetFields(['district', 'districtCode', 'subDistrict', 'subDistrictCode', 'postCode'])
        setIsPostCode(false)
        isSelect.current = true
    }

    const onSelectCurrentProvince = async (provCode) => {
        const _province = currentProvince.find(e => e.value === provCode)
        if (_province) {
            setIsLoading(true)
            const provinceValue = (_province ? _province.code : null)
            setCurrentProvinceCode(provinceValue)
            const districtData = await getDataAddress(provinceValue, 'district');
            if (districtData && districtData.length > 0) {
                setCurrentDistrict(districtData.sort((a, b) => a.label.localeCompare(b.label)))
            }

            form.setFieldValue('currentProvince', provinceValue)
            form.setFieldValue('currentProvinceCode', (_province ? _province.label : null))
            setIsLoading(false)
            setIsCurrentDistrict(true)
            setIsCurrentSubDistrict(false)
        } else {
            form.resetFields(['currentProvince', 'currentProvinceCode'])
            setIsCurrentDistrict(false)
            setIsCurrentSubDistrict(false)
        }
        form.resetFields([
            'currentDistrict',
            'currentDistrictCode',
            'currentSubDistrict',
            'currentSubDistrictCode',
            'currentPostCode'])
        setIsCurrentPostCode(false)
        isCurrentSelect.current = true
    }

    const onSelectDistrict = async (amphCode) => {
        const _district = district.find(e => e.value === amphCode)
        if (_district) {
            setIsLoading(true)
            const districtValue = (_district ? _district.code : null)
            const val = {
                province: provinceCode,
                district: districtValue
            }
            const subDistrictData = await getDataAddress(val, 'subdistrict');
            if (subDistrictData && subDistrictData.length > 0) {
                setSubDistrict(subDistrictData.sort((a, b) => a.label.localeCompare(b.label)))
            }

            form.setFieldValue('district', districtValue)
            form.setFieldValue('districtCode', (_district ? _district.label : null))
            setIsLoading(false)
            setIsSubDistrict(true)
        } else {
            form.resetFields(['district', 'districtCode'])
            setIsSubDistrict(false)
        }
        form.resetFields(['subDistrict', 'subDistrictCode', 'postCode'])
        isSelect.current = true
        setIsPostCode(false)
    }

    const onSelectCurrentDistrict = async (amphCode) => {
        const _district = currentDistrict.find(e => e.value === amphCode)
        if (_district) {
            setIsLoading(true)
            const districtValue = (_district ? _district.code : null)
            const val = {
                province: currentProvinceCode,
                district: districtValue
            }
            const subDistrictData = await getDataAddress(val, 'subdistrict');
            if (subDistrictData && subDistrictData.length > 0) {
                setCurrentSubDistrict(subDistrictData.sort((a, b) => a.label.localeCompare(b.label)))
                setCurrentPostCode(setDataZipCode(subDistrictData))
            }

            form.setFieldValue('currentDistrict', districtValue)
            form.setFieldValue('currentDistrictCode', (_district ? _district.label : null))
            setIsLoading(false)
            setIsCurrentSubDistrict(true)
        } else {
            form.resetFields(['currentDistrict', 'currentDistrictCode'])
            setIsCurrentSubDistrict(false)
        }
        form.resetFields(['currentSubDistrict', 'currentSubDistrictCode', 'currentPostCode'])
        isCurrentSelect.current = true
        setIsCurrentPostCode(false)
    }

    const onSelectSubDistrict = async (val) => {
        setIsLoading(true)
        form.setFieldValue('postCode', null)
        if (subDistrict && subDistrict.length > 0) {
            const data = subDistrict.filter(item => item.value === val)
            if (data && data.length > 0) {
                console.log('onSelectSubDistirct', data)
                form.setFieldValue('subDistrict', data[0].code)
                form.setFieldValue('subDistrictCode', data[0].label)
                // form.setFieldValue('postCode', data[0].zipCode)
                const zipCodeData = setDataZipCode(data)
                if (zipCodeData?.length > 0) {
                    form.setFieldValue('postCode', zipCodeData[0].value)
                    setPostCode(zipCodeData)
                }
            }
        }
        isSelect.current = true
        setIsLoading(false)
        setIsPostCode(true)
    }

    const onSelectCurrentSubDistrict = async (val) => {
        setIsLoading(true)
        form.setFieldValue('currentPostCode', null)
        if (currentSubDistrict && currentSubDistrict.length > 0) {
            const data = currentSubDistrict.filter(item => item.value === val)
            if (data && data.length > 0) {
                form.setFieldValue('currentSubDistrict', data[0].code)
                form.setFieldValue('currentSubDistrictCode', data[0].label)
                // form.setFieldValue('currentPostCode', data[0].zipCode)
                const zipCodeData = setDataZipCode(data)
                if (zipCodeData?.length > 0) {
                    form.setFieldValue('currentPostCode', zipCodeData[0].value)
                    setCurrentPostCode(zipCodeData)
                }
            }
        }
        isCurrentSelect.current = true
        setIsLoading(false)
        setIsCurrentPostCode(true)
    }

    const onChange = async (e, columnName) => {
        const val = e?.target?.value ? (e.target.value) : null

        if (columnName === 'provinceCode') {
            const _province = province.find(e => e.value === val)
            if (!val || val === '' || !_province) {
                setIsDistrict(false)
                setIsSubDistrict(false)
                setIsPostCode(false)
                form.resetFields(['province', 'provinceCode', 'district', 'districtCode', 'subDistrict', 'subDistrictCode', 'postCode'])
            } else {
                if (!isSelect.current && !_province) {
                    onSelectProvince(val)
                }
            }
        } else if (columnName === 'districtCode') {
            const _district = district.find(e => e.value === val)
            if (!val || val === '' || !_district) {
                setIsSubDistrict(false)
                setIsPostCode(false)
                form.resetFields(['district', 'districtCode', 'subDistrict', 'subDistrictCode', 'postCode'])
            } else {
                if (!isSelect.current && !_district) {
                    onSelectDistrict(val)
                }
            }
        } else if (columnName === 'subDistrictCode') {
            const _subDistrict = subDistrict.find(e => e.value === val)
            if (!val || val === '' || !_subDistrict) {
                setIsPostCode(false)
                form.resetFields(['subDistrict', 'subDistrictCode', 'postCode'])
            }
        } else if (columnName === 'postCode') {
            const _postCode = postCode.find(e => e.value === val)
            if (!val || !_postCode) {
                form.resetFields(['postCode'])
            }
        }
        isSelect.current = false
    }

    const onChangeCurrent = async (e, columnName) => {
        const val = e?.target?.value ? (e.target.value) : null

        if (columnName === 'currentProvinceCode') {
            const _province = currentProvince.find(e => e.value === val)
            if (!val || val === '' || !_province) {
                setIsCurrentDistrict(false)
                setIsCurrentSubDistrict(false)
                setIsCurrentPostCode(false)
                form.resetFields([
                    'currentProvince',
                    'currentProvinceCode',
                    'currentDistrict',
                    'currentDistrictCode',
                    'currentSubDistrict',
                    'currentSubDistrictCode',
                    'currentPostCode'])
            } else {
                if (!isCurrentSelect.current && !_province) {
                    onSelectCurrentProvince(val)
                }
            }
        } else if (columnName === 'currentDistrictCode') {
            const _district = currentDistrict.find(e => e.value === val)
            if (!val || val === '' || !_district) {
                setIsCurrentSubDistrict(false)
                setIsCurrentPostCode(false)
                form.resetFields([
                    'currentDistrict',
                    'currentDistrictCode',
                    'currentSubDistrict',
                    'currentSubDistrictCode',
                    'currentPostCode'])
            } else {
                if (!isCurrentSelect.current && !_district) {
                    onSelectCurrentDistrict(val)
                }
            }
        } else if (columnName === 'currentSubDistrictCode') {
            const _subDistrict = currentSubDistrict.find(e => e.value === val)
            if (!val || val === '' || !_subDistrict) {
                setIsCurrentPostCode(false)
                form.resetFields(['currentSubDistrict', 'currentSubDistrictCode', 'currentPostCode'])
            }
        } else if (columnName === 'currentPostCode') {
            const postCode = currentPostCode.find(e => e.value === val)
            if (!val || !postCode) {
                form.resetFields(['currentPostCode'])
            }
        }
        isCurrentSelect.current = false
    }

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            isSelect.current = false
        }
    }

    const handleCurrentKeyDown = (event) => {
        if (event.key === 'Enter') {
            isCurrentSelect.current = false
        }
    }

    const handleChange = (e, columnName) => {
        let inputValue = e.target.value;
        const reg = /^-?\d*(\.\d*)?$/;
        if (!(reg.test(inputValue) || inputValue === '' || inputValue === '-')) {
            inputValue = inputValue.length > 0 ? (inputValue.substring(0, inputValue.length - 1)) : ''
        }

        if (!reg.test(inputValue)) {
            form.setFieldsValue({ [columnName]: null });
        } else {
            form.setFieldsValue({ [columnName]: inputValue });
        }

        if (inputValue && inputValue.length < 10 && columnName === 'phone') {
            form.setFields([{ name: ['phone'], errors: ['ต้องกรอกให้ครบ 10 หลักเท่านั้น'] }]);
        }
    }

    const handleCheckPermanentAddress = (e) => {
        const checked = e.target.checked ?? false
        if (checked) {
            form.setFieldsValue({
                currentAddress: form.getFieldValue('address'),
                currentProvinceCode: form.getFieldValue('provinceCode'),
                currentDistrictCode: form.getFieldValue('districtCode'),
                currentSubDistrictCode: form.getFieldValue('subDistrictCode'),
                currentProvince: form.getFieldValue('province'),
                currentDistrict: form.getFieldValue('district'),
                currentSubDistrict: form.getFieldValue('subDistrict'),
                currentPostCode: form.getFieldValue('postCode'),
            })
        } else {
            form.setFieldsValue({
                currentAddress: null,
                currentProvinceCode: null,
                currentDistrictCode: null,
                currentSubDistrictCode: null,
                currentProvince: null,
                currentDistrict: null,
                currentSubDistrict: null,
                currentPostCode: null,
            })
        }
    }

    const validatePhoneLength = (_, value) => {
        if (value && value.length < 10) {
            return Promise.reject("ต้องกรอกให้ครบ 10 หลักเท่านั้น");
        }
        return Promise.resolve();
    };


    const setDataZipCode = (data) => {
        if (data?.length > 0) {
            const uniqueZipCodes = [
                ...new Set(
                    data.flatMap(item => item.zipCode.split(',').map(zip => zip.trim())) // Split and trim zip codes, then create a Set to ensure uniqueness
                )
            ]
                .sort((a, b) => a.localeCompare(b)) // Sort the unique zip codes
                .map(zipCode => ({
                    label: zipCode,
                    value: zipCode
                }));
            return uniqueZipCodes
        }
        return null
    }

    const AddressBox = ({ name, label, requried = false, props, onChange = () => { } }) => {
        const maxLength = ['address', 'currentAddress'].includes(name) ? 255
            : ['floor', 'currentFloor'].includes(name) ? 3 : 50
        return (
            <Col xs={24} md={8} className='px-2'>
                <InputUC
                    required={requried ?? false}
                    label={label}
                    name={name}
                    maxLength={maxLength}
                    autoComplete='new-password'
                    disabled={name.includes('current') ? isPermanentAddressWatch : false}
                    onChange={onChange}
                    {...props} />
            </Col>
        )
    }

    return (
        <div className="contact content-block p-3">
            <div className="block-title">ข้อมูลการติดต่อ</div>
            <div className={"header-bar-title"}>ที่อยู่ตามทะเบียนบ้าน</div>
            <Row className="py-2">
                <Col hidden={true}><AddressBox name='address' label='ที่อยู่' /></Col>
                <Col xs={24} md={8} className='px-2'>
                    <InputUC label='เลขที่'
                        maxLength={50}
                        required={true}
                        name={'addressNo'} />
                </Col>
                <AddressBox name='moo' label='หมู่ที่' />
                <AddressBox name='building' label='อาคาร' />
            </Row>
            <Row className="py-2">
                <AddressBox name='roomNumber' label='เลขที่ห้อง' />
                <AddressBox name='floor' label='ชั้นที่' onChange={(e) => handleChange(e, 'floor')} />
                <AddressBox name='village' label='หมู่บ้าน' />
            </Row>
            <Row className="py-2">
                <AddressBox name='lane' label='ตรอก/ซอย' />
                <AddressBox name='road' label='ถนน' />
                <Col xs={24} md={8} className='px-2'>
                    <AutoCompleteUC required={true} label='จังหวัด' name={'provinceCode'} options={province}
                        onSelect={onSelectProvince} onBlur={val => onChange(val, 'provinceCode')} onKeyDown={handleKeyDown} />
                    <InputUC hidden={true} required={true} name={'province'} />
                </Col>
            </Row>

            <Row className="py-2">
                <Col xs={24} md={8} className='px-2'>
                    <AutoCompleteUC required={isDistrict}
                        disabled={!isDistrict} label='เขต/อำเภอ' name={'districtCode'}
                        options={district} onBlur={val => onChange(val, 'districtCode')} onSelect={onSelectDistrict} onKeyDown={handleKeyDown} />
                    <InputUC hidden={true} required={true} name={'district'} />
                </Col>
                <Col xs={24} md={8} className='px-2'>
                    <AutoCompleteUC required={isSubDistrict} label='แขวง/ตำบล' name={'subDistrictCode'} options={subDistrict}
                        onSelect={onSelectSubDistrict} disabled={!isSubDistrict} onBlur={val => onChange(val, 'subDistrictCode')}
                        onKeyDown={handleKeyDown} />
                    <InputUC hidden={true} required={true} name={'subDistrict'} />
                </Col>
                <Col xs={24} md={8} className='px-2'>
                    <AutoCompleteUC
                        required={isPostCode}
                        label='รหัสไปรษณีย์'
                        name={'postCode'}
                        options={postCode}
                        disabled={!isPostCode || !postCode || postCode?.length === 1}
                        onKeyDown={handleKeyDown}
                        onBlur={val => onChange(val, 'postCode')} />
                    {/* <InputUC label='รหัสไปรษณีย์'
                        maxLength={5}
                        required={isPostCode}
                        showPlaceholder={false}
                        name={'postCode'}
                        onChange={(e) => handleChange(e, 'postCode')}
                        disabled={!isPostCode} /> */}
                </Col>
            </Row>

            <div className={"header-bar-title mt-6"}>ที่อยู่ปัจจุบัน</div>
            <Row className="py-2">
                <Col xs={24} md={8} className='px-2 flex justify-start items-center div-checkbox'>
                    <CheckBoxUC isShowHead={false}
                        label='ที่อยู่เดียวกับที่อยู่ตามทะเบียนบ้าน'
                        name={'isPermanentAddress'}
                        onChange={handleCheckPermanentAddress} />
                </Col>
            </Row>
            {!isPermanentAddressWatch &&
                <>
                    <Row className="py-2">
                        <Col hidden={true}><AddressBox name='currentAddress' label='ที่อยู่' /></Col>
                        <Col xs={24} md={8} className='px-2'>
                            <InputUC label='เลขที่'
                                maxLength={50}
                                required={true}
                                name={'currentAddressNo'} />
                        </Col>
                        <AddressBox name='currentMoo' label='หมู่ที่' />
                        <AddressBox name='currentBuilding' label='อาคาร' />
                    </Row>
                    <Row className="py-2">
                        <AddressBox name='currentRoomNumber' label='เลขที่ห้อง' />
                        <AddressBox name='currentFloor' label='ชั้นที่' onChange={(e) => handleChange(e, 'currentFloor')} />
                        <AddressBox name='currentVillage' label='หมู่บ้าน' />
                    </Row>
                    <Row className="py-2">
                        <AddressBox name='currentLane' label='ตรอก/ซอย' />
                        <AddressBox name='currentRoad' label='ถนน' />
                        <Col xs={24} md={8} className='px-2'>
                            <AutoCompleteUC label='จังหวัด'
                                disabled={isPermanentAddressWatch}
                                name={'currentProvinceCode'}
                                options={currentProvince}
                                required={true}
                                onSelect={onSelectCurrentProvince}
                                onBlur={val => onChangeCurrent(val, 'currentProvinceCode')}
                                onKeyDown={handleCurrentKeyDown} />
                            <InputUC hidden={true} name={'currentProvince'} />
                        </Col>
                    </Row>
                    <Row className="py-2">
                        <Col xs={24} md={8} className='px-2'>
                            <AutoCompleteUC
                                disabled={!isCurrentDistrict || isPermanentAddressWatch} label='เขต/อำเภอ' name={'currentDistrictCode'}
                                options={currentDistrict}
                                required={isCurrentDistrict}
                                onBlur={val => onChangeCurrent(val, 'currentDistrictCode')}
                                onSelect={onSelectCurrentDistrict}
                                onKeyDown={handleCurrentKeyDown} />
                            <InputUC hidden={true} name={'currentDistrict'} />
                        </Col>
                        <Col xs={24} md={8} className='px-2'>
                            <AutoCompleteUC
                                label='แขวง/ตำบล'
                                name={'currentSubDistrictCode'}
                                options={currentSubDistrict}
                                required={isCurrentSubDistrict}
                                onSelect={onSelectCurrentSubDistrict}
                                disabled={!isCurrentSubDistrict || isPermanentAddressWatch}
                                onBlur={val => onChangeCurrent(val, 'currentSubDistrictCode')}
                                onKeyDown={handleCurrentKeyDown} />
                            <InputUC hidden={true} name={'currentSubDistrict'} />
                        </Col>
                        <Col xs={24} md={8} className='px-2'>
                            <AutoCompleteUC
                                required={isCurrentPostCode}
                                label='รหัสไปรษณีย์'
                                name={'currentPostCode'}
                                options={currentPostCode}
                                disabled={!isCurrentPostCode || isPermanentAddressWatch || !currentPostCode || currentPostCode?.length === 1}
                                onKeyDown={handleKeyDown}
                                onBlur={val => onChangeCurrent(val, 'currentPostCode')} />
                            {/* <InputUC label='รหัสไปรษณีย์'
                                maxLength={5}
                                required={isCurrentPostCode}
                                showPlaceholder={false}
                                name={'currentPostCode'}
                                onChange={(e) => handleChange(e, 'currentPostCode')}
                                disabled={!isCurrentPostCode || isPermanentAddressWatch} /> */}
                        </Col>
                    </Row>
                </>
            }

            <Row className="py-2">
                <Col xs={24} md={8} className='px-2'>
                    <InputUC required={true}
                        label='เบอร์โทรศัพท์'
                        name={'phone'}
                        maxLength={10}
                        rules={[
                            { required: true, message: "กรุณากรอก เบอร์โทรศัพท์" },
                            { validator: validatePhoneLength },
                        ]}
                        onChange={(e) => handleChange(e, 'phone')} />
                </Col>
                <Col xs={24} md={16} className='px-2'>
                    <InputUC required={true} label='อีเมล' name={'email'} disabled={true} showPlaceholder={false} />
                </Col>
            </Row>

            <Row className="py-2">
                <Col xs={24} md={24} className='px-2'>
                    <InputUC
                        label='Facebook'
                        name={'facebook'}
                        maxLength={255} />
                </Col>
            </Row>
        </div>
    )
}

export default Contact